import Slideout from 'slideout';

export const intMobileMenu = () => {
  const slideout = new Slideout({
    'panel': document.getElementById('panel'),
    'menu': document.getElementById('menu'),
    'padding': 200,
    'tolerance': 70,
    'side': 'right',
    'touch': false
  });

  [].slice.call(document.getElementsByClassName('toggle-button')).forEach(elem => {
    elem.addEventListener('click', function () {
      slideout.toggle();
    });
  });

  let menu = slideout.menu;
  slideout.menu = slideout.panel;
  slideout.panel = menu;

  return slideout;
};
